module.exports = "<taxihandgo-field #nir (paste)=\"onPaste($event)\" (valueChange)=\"update()\" [length]=\"13\">Numéro de sécurité sociale</taxihandgo-field>\n<taxihandgo-field #key (valueChange)=\"update()\" [length]=\"2\">Clé</taxihandgo-field>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nir/nir.component.html
// module id = 496
// module chunks = 1